import type { RuleDefinition } from '../domain/types';
import { getCellText } from '../domain/cells';
import { compareAmount } from '../utils/number';
import { cellValueForParsing, finding, isFormulaWithoutResult } from './helpers';

export const BQ008: RuleDefinition = {
  id: 'BQ008',
  name: '行金额计算不一致',
  description: '使用十进制定点运算比较“工程量 × 综合单价”和合价。',
  defaultSeverity: 'error',
  enabled: true,
  applicableFields: ['quantity', 'unitPrice', 'amount'],
  message: '工程量与综合单价的乘积和合价不一致。',
  suggestion: '请回到原文件核对工程量、综合单价、合价以及公式；本工具不修改源文件。',
  check: ({ detailRows, settings }) =>
    detailRows.flatMap((row) => {
      if (
        isFormulaWithoutResult(row, 'quantity') ||
        isFormulaWithoutResult(row, 'unitPrice') ||
        isFormulaWithoutResult(row, 'amount')
      ) {
        return [];
      }
      const comparison = compareAmount(
        cellValueForParsing(row, 'quantity'),
        cellValueForParsing(row, 'unitPrice'),
        cellValueForParsing(row, 'amount'),
        settings.amountTolerance,
      );
      if (comparison === null || comparison.withinTolerance) return [];
      return [
        finding(row, 'amount', {
          currentValue: getCellText(row, 'amount'),
          message: `计算值 ${comparison.expected.toString()}，当前合价 ${comparison.actual.toString()}，差额 ${comparison.difference.toString()}，允许容差 ${comparison.allowedTolerance.toString()}。`,
        }),
      ];
    }),
};
